import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class TaxmetadataService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }

   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

  // Create taxMetadata
  createTaxMetadata(user: Object): Observable<Object> {
    console.log("In createSoftwares method, TaxMetadata: ", user);
    return this.http.post(`${environment.apiUrl}/taxMetadata`, user).pipe(catchError(this.handleError));
  }

   // Get taxMetadata by Id Get
   getTaxMetadata(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/taxMetadata/${id}`).pipe(catchError(this.handleError));
  }

   //Delete taxMetadata by Id Delete
   deletetaxMetadata(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/taxMetadata/${id}`).pipe(catchError(this.handleError));
  }

   //Update taxMetadata by Id Put
   updatetaxMetadata(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/taxMetadata/${id}`, user).pipe(catchError(this.handleError));
  }

  public getTaxmetaDataById(Id: number) {
    return this.http.get<any>(`${environment.apiUrl}/taxMetadata/${Id}`).pipe(catchError(this.handleError));
  }

   //Get All taxMetadata by Id Get
   getAlltaxMetadata(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/taxMetadata`).pipe(catchError(this.handleError));
  }

}
